import React from 'react';
import { getProductImageUrl } from '../../../../utils/productHelpers';

const ItemThumbnails = ({ items }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {items.map(item => (
        <div 
          key={item.id || item.cartItemIndex} 
          className={`w-16 relative ${item.isUnshippable ? 'opacity-40' : ''}`}
        >
          <div className="h-16 w-16 overflow-hidden rounded-md">
            <img 
              src={getProductImageUrl(item)}
              alt={item.name || item.product?.name}
              className="h-full w-full object-cover object-center"
            />
          </div>
          <div className="text-xs mt-1 truncate text-center">
            {item.name || item.product?.name}
          </div>
          {item.isUnshippable && (
            <div className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full h-4 w-4 flex items-center justify-center text-xs">
              !
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ItemThumbnails; 